import { createSlice } from '@reduxjs/toolkit';
import { set } from 'lodash-es';
const initialState = {};
export const errorsSlice = createSlice({
    name: 'form-errors',
    initialState,
    reducers: {
        setFormError: (state, action) => {
            const { form, name = null, messages: payloadMessages = null, errors: payloadErrors = null, } = action.payload;
            if (name && typeof name === 'string') {
                const messages = Array.isArray(payloadMessages)
                    ? payloadMessages
                    : [payloadMessages];
                state[form] = set(state[form], name, messages);
            }
            if (payloadErrors) {
                const newErrors = Array.isArray(payloadErrors)
                    ? payloadErrors
                    : Object.keys(payloadErrors).map((name) => {
                        return {
                            name,
                            messages: payloadErrors[name],
                        };
                    });
                let errors = state[form] ? state[form] : {};
                for (let index = 0; index < newErrors.length; index++) {
                    const error = newErrors[index];
                    set(errors, error.name, error.messages);
                }
                state[form] = errors;
            }
        },
        clearFormErrors: (state, action) => {
            const { form } = action.payload;
            state[form] = {};
        },
    },
});
export const { setFormError, clearFormErrors } = errorsSlice.actions;
export default errorsSlice.reducer;
